import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";
import Loc from "../services/localization";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'date','startAt', 'trainingType'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            users: [],
            hasError: '',
            currentDate: '',
            startAtTime: '',
            filter: '',
            trainings: [],
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.currentDate = this.date;
                this.startAtTime = this.startAt;
                this.getTrainings();
            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeSeeTrainings')
            this.trainings = []
            this.currentDate = ''
            this.startAtTime = ''
        },
        keymonitor: keymonitor,
        getTrainings: getTrainings,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--medium'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: #1C242D;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;overflow: auto;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'height: 400px !important;';
            }
            return 'height: 600px !important;';
        }

    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}


function getTrainings() {
    let _self = this;
    AdminApiService.getTrainingsByDate(this.date)
        .then((response) => {
            _self.trainings = response.data.filter( t =>  t.trainingType === _self.trainingType && t.startAt === _self.startAtTime)
        })
        .catch(error => {
            console.log(error);
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}




// WEBPACK FOOTER //
// ./src/modals/SeeTrainingsModal.js